/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zippy_Lime_Marmot_QuizInputs */

const fr_zippy_lime_marmot_quiz = /** @type {(inputs: Zippy_Lime_Marmot_QuizInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme personnalisé`)
};

/**

* @param {Zippy_Lime_Marmot_QuizInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zippy_lime_marmot_quiz = /** @type {((inputs?: Zippy_Lime_Marmot_QuizInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zippy_Lime_Marmot_QuizInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zippy_lime_marmot_quiz(inputs)
});